import { appLocalStorage } from '../utils/storage';
import config from '../utils/config';
export const LEGAL_VERSION = '2026-10-16';
let presenter = null;
export function registerLegalPresenter(handler) {
  presenter = handler;
  return () => { if (presenter === handler) presenter = null; };
}
export function manageLegalConsent() {
  const token = appLocalStorage.getItem(config.token);
  return presenter && token ? presenter({ token, manage: true }) : Promise.resolve(false);
}
